import {Component, Input, OnInit} from '@angular/core';
import {Sponsor} from '@shared/models/sponsor';
import {ImageService} from '@utils/services/image/image.service';
import {IMAGE_RESOLUTION} from '@api/models/image/image-resolution';
import {ImageSubType} from '@api/models/image/image-type';

@Component({
  selector: 'app-team-league-sponsor-card',
  templateUrl: './team-and-league-sponsor-card.component.html',
  styleUrls: ['./team-and-league-sponsor-card.component.scss'],
})

export class TeamAndLeagueSponsorCardComponent implements OnInit {

  @Input() sponsor: Sponsor;
  @Input() simpleDesign: boolean = false;
  public resizedImageSrc: string;

  public ngOnInit() {
    this.resizedImageSrc = ImageService.findPictureUrlBySubType(
      this.sponsor.pictures, ImageSubType.IMAGE, IMAGE_RESOLUTION.MEDIUM);
  }
}
